import {
  CHECKOUT_API_REQUEST,
  CHECKOUT_API_SUCCESS,
  CHECKOUT_API_ERROR,
  CHECKOUT_SUCCESS,
} from '../../../constants/cartActionNames';

import { cartApi } from '../../../apis/cart';

function checkoutApiRequest() {
  return {
    type: CHECKOUT_API_REQUEST,
    payload: true,
  };
}

function checkoutApiSuccess(cart, params) {
  return {
    type: CHECKOUT_API_SUCCESS,
    payload: cart,
    params,
  };
}

function checkoutApiError(err) {
  return {
    type: CHECKOUT_API_ERROR,
    payload: err,
  };
}

function checkoutSuccess(params) {
  return {
    type: CHECKOUT_SUCCESS,
    payload: params,
    params,
  };
}

export function checkoutAction(params) {
  return (dispatch, getState) => {
    const state = getState();
    const { isAuthenticated } = state.auth;
    // if (!isAuthenticated) {
    //   dispatch(checkoutSuccess(params));
    //   return Promise.resolve(params);
    // }
    dispatch(checkoutApiRequest());
    return cartApi
      .checkout(state, params)
      .then(data => {
        dispatch(checkoutApiSuccess(data, params));
        return data;
      })
      .catch(error => {
        dispatch(checkoutApiError(error));
        throw error;
      });
  };
}

export default { checkoutAction };
